export default {
  cataloger: {
    materials: {
      title: 'Requested Materials',
    },
    catalog: {
      title: 'Catalog',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/routes/cataloger.js